// extracted by mini-css-extract-plugin
export default {"main":"styles_main__1h+3h","name":"styles_name__7sBjf","leftName":"styles_leftName__KfMO-","points":"styles_points__h-5Aq","winner":"styles_winner__JSTdI"};